import { ColourMod, FlexAlign } from '../../../Data/Enums/LayoutEnums';
import StackHorizontal from '../../Wrappers/StackHorizontal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faGripLines, faTrash } from '@fortawesome/pro-solid-svg-icons';
import Button from '../../Buttons/Button';
import StackVertical from '../../Wrappers/StackVertical';
import { GetReadableFileSize } from '../../../Constants/Helpers';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { UploadFileDetailsDragPlaceHolder } from './UploadFileTypes';
import React, { useEffect, useRef } from 'react';

const UploadFileEntriesDragPlaceholder = (props: UploadFileDetailsDragPlaceHolder) => {
	const dragRef = useRef<HTMLDivElement>(null);

	const PositionState = (state: boolean) => {
		if (dragRef.current) {
			if (state) {
				dragRef.current.style.opacity = '1';
			} else {
				dragRef.current.style.opacity = '0';
				dragRef.current.style.left = '-1000px';
				dragRef.current.style.top = '-1000px';
			}
		}
	};

	const MouseMoveHandler = (e: MouseEvent) => {
		if (dragRef.current) {
			dragRef.current.style.left = e.pageX - dragRef.current.getBoundingClientRect().width / 2 + 'px';
			dragRef.current.style.top = e.pageY - dragRef.current.getBoundingClientRect().height / 2 + 'px';
		}
	};

	useEffect(() => {
		document.addEventListener('dragover', MouseMoveHandler);
		document.addEventListener('pointermove', MouseMoveHandler);
		return () => {
			document.removeEventListener('dragover', MouseMoveHandler);
			document.removeEventListener('pointermove', MouseMoveHandler);
		};
	}, []);

	useEffect(() => {
		PositionState(props.dragActive);
	}, [props.dragActive]);

	return (
		<div
			ref={dragRef}
			className={'drag-dummy'}
			style={{
				width:
					dragRef.current && dragRef.current.parentElement
						? `${dragRef.current.parentElement.getBoundingClientRect().width}px`
						: '0',
				height: props.itemHeight,
			}}
		>
			<div className={`upload-file-entry upload-file-entry-d-d ${!props.valid ? ColourMod.Alert : ''} `}>
				<StackHorizontal>
					<div className={'p-sm'}>
						<FontAwesomeIcon icon={faGripLines} />
					</div>
					<Button squared title={'Preview'} extraClass={'m-0'} disabled>
						<FontAwesomeIcon icon={faEye} />
					</Button>
				</StackHorizontal>
				<StackVertical align={FlexAlign.Start}>
					<div className={'upload-file-entry-name'}>{props.file.name}</div>
					<span className={'upload-file-entry-size'}>{GetReadableFileSize(props.file.size)}</span>
				</StackVertical>
				<div className={'upload-file-entry-actions'}>
					<div className={`upload-file-entry-action upload-file-entry-valid`}>
						{props.valid && <FontAwesomeIcon icon={faCheck} />}
					</div>
				</div>
				<Button
					title={`Remove ${props.file.name}`}
					icon={<FontAwesomeIcon icon={faTrash} fixedWidth={true} />}
					iconOnly
					extraClass={`upload-file-entry-action upload-file-entry-remove`}
					colour={ColourMod.Alert}
					disabled
				/>
			</div>
		</div>
	);
};

export { UploadFileEntriesDragPlaceholder };
